const cancelFrame = (frameId) => {
  window.cancelAnimationFrame(frameId);
};

export default cancelFrame;
